import { useApiQuery } from '@common/hooks';
import { SkipOrArgs } from '@common/types/queryState';
import { useSelectedProductionId } from '@features/productions';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetMetricsCollectionQuery } from '../api';
import { GetMetricsCollectionArgs } from '../types';
import { mergeWithDefault } from '@common/utils';
import { DEFAULT_METRICS_COLLECTION } from '../mappers';

export const useMetricsCollection = () => {
    const productionId = useSelectedProductionId();

    const queryArgs: SkipOrArgs<GetMetricsCollectionArgs> = useMemo(() => {
        if (!productionId) return skipToken;
        return { productionId };
    }, [productionId]);

    const { data, ...queryResult } = useApiQuery(
        useGetMetricsCollectionQuery,
        queryArgs,
    );
    const metrics = mergeWithDefault(data, DEFAULT_METRICS_COLLECTION);

    return { metrics, ...queryResult };
};
